import { globalState } from '../models';

export default function useOpenDocumentId() {
  return globalState((state) => state.openDocumentId);
}
